__turbopack_context__.v({
  "bodyContainer": "ONWivG_bodyContainer",
  "bodyPrimary": "ONWivG_bodyPrimary",
  "bodySecondary": "ONWivG_bodySecondary",
  "buttonsRow": "ONWivG_buttonsRow",
  "contentContainer": "ONWivG_contentContainer",
  "extraContent": "ONWivG_extraContent",
  "footerContainer": "ONWivG_footerContainer",
  "headerRow": "ONWivG_headerRow",
  "root": "ONWivG_root",
  "title": "ONWivG_title",
  "titleContainer": "ONWivG_titleContainer",
});
